<template>
  <div class="w-4/5 md:w-2/5 absolute top-0 right-0 bg-white h-full">
    <div class="header-title p-5 border-0 border-b border-gray-300 border-solid">
      <h5 class="text-center font-bold">{{ $t(`TRANSFERVIEW.transferFormsCompany`) }}</h5>
    </div>
    <div class="body flex flex-col justify-between px-5 h-body pb-1">
      <vs-select
        autocomplete
        class="mt-2 w-full"
        :label="$t(`TRANSFERVIEW.originCompany`)"
        v-model="idCompany"
        @change="getForms(idCompany)"
      >
        <vs-select-item :key="index" :value="item.key" :text="item.name" v-for="(item, index) in companies" />
      </vs-select>
      <vs-select
        autocomplete
        class="w-full"
        :label="$t(`TRANSFERVIEW.destinityCompany`)"
        v-model="idCompanyEnd"
        @change="getGroups(idCompanyEnd)"
      >
        <vs-select-item :key="index" :value="item.key" :text="item.name" v-for="(item, index) in companiesEnd" />
      </vs-select>
      <vs-select autocomplete class="w-full" :label="$t(`TRANSFERVIEW.group`)" v-model="idGroup">
        <vs-select-item :key="index" :value="item.key" :text="item.name" v-for="(item, index) in groups" />
      </vs-select>

      <vs-button :disabled="disabledBotton" class="w-full" color="success" type="border" @click="transferForms">{{
        $t(`TRANSFERVIEW.toTransfer`)
      }}</vs-button>
    </div>
  </div>
</template>

<script>
import Api from "@/helpers/api";
export default {
  data() {
    return {
      idCompany: this.$store.state.user.companyID,
      idCompanyEnd: "",
      idGroup: "",
      companies: [],
      groups: []
    };
  },
  mounted() {
    this.getcompanies();
    this.getForms(this.idCompany);
  },
  methods: {
    async getcompanies() {
      try {
        const result = await Api.get("/companies");
        this.companies = result.data
          .filter(({ status }) => status === "Active")
          .map(({ name, key }) => ({ name, key }));
        return result;
      } catch (error) {
        console.log("Error: getcompanies", error);
        throw error;
      }
    },
    async getGroups(idCompanyEnd) {
      try {
        const data = {
          companyID: idCompanyEnd,
          table: "Groups",
          fields: ["name"],
          limit: 200
        };
        const result = await Api.post("/fql", data);
        this.groups = result.data;
      } catch (error) {
        this.idGroup = "";
        console.log("Error: getGroups", error);
      }
    },
    async getForms(idCompany) {
      try {
        this.$vs.loading({
          container: "#todo-app",
          scale: 0.6
        });
        await this.$store.dispatch("transer/fetchTasks", idCompany);
        this.$store.commit("transer/GET_KEYS_FORMS", "");
        this.idCompanyEnd = "";
        this.idGroup = "";
      } catch (error) {
        console.log("Error: getForms", error);
      } finally {
        this.$vs.loading.close("#todo-app > .con-vs-loading");
      }
    },
    async transferForms() {
      try {
        this.$vs.loading({
          container: "#todo-app",
          scale: 0.6
        });
        const data = {
          origin: {
            companyID: this.idCompany,
            formID: this.getKeyForm
          },
          destiny: {
            companyID: this.idCompanyEnd,
            groupID: this.idGroup
          }
        };
        await Api.post("/forms/transfer", data);
        this.$vs.notify({
          title: this.$t(`TRANSFERVIEW.transfer`),
          text: this.$t(`TRANSFERVIEW.successTransfer`),
          position: "top-right",
          color: "primary"
        });
        this.idCompanyEnd = "";
        this.idGroup = "";
        this.$store.commit("transer/GET_KEYS_FORMS", "");
      } catch (error) {
        console.log("Error: transferForms ", error);
      } finally {
        this.$vs.loading.close("#todo-app > .con-vs-loading");
      }
    }
  },
  computed: {
    companiesEnd() {
      return this.companies.filter(company => company.key !== this.idCompany);
    },
    getKeyForm() {
      return this.$store.state.transer.keyForm;
    },
    isEmptyKeysForms() {
      return this.getKeyForm.length === 0 || this.getKeyForm.length === "";
    },
    isSelectedCompanyEnd() {
      return this.idCompanyEnd.length === 0 || this.idCompanyEnd === "";
    },
    isSelectedGroup() {
      return this.idGroup.length === 0 || this.idGroup === "";
    },
    disabledBotton() {
      return this.isEmptyKeysForms || this.isSelectedCompanyEnd || this.isSelectedGroup;
    }
  }
};
</script>

<style lang="scss" scoped>
.border-gray-300 {
  border-color: #e2e8f0;
}

.h-body {
  height: calc(100% - 75px);
}
</style>
